import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment/moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitDnataExtraForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const WishForm = ({
  appData: { dnataOnboarding, firstName, lastName, nationalInsuranceNo },
  submitForm,
}) => {
  const typeCode = "YDN7";
  const fullName = `${firstName} ${lastName}`;
  const submitted = dnataOnboarding && dnataOnboarding[typeCode];

  const initialData = {
    employeeName: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
    ni: nationalInsuranceNo || "",
    scheme: "Alpha LSG Ltd Group Death In Service Scheme",
  };
  const getVal = getField(initialData);

  const personData = {
    name: {
      title: "Full Name",
      value: "",
      mandatory: true,
    },
    address: {
      title: "Address",
      value: "",
      mandatory: true,
    },
    relationship: {
      title: "Relationship",
      value: "",
      mandatory: true,
    },
    proportion: {
      title: "Proportion of sum",
      value: "",
      mandatory: true,
    },
  };

  const personsDataObj = Object.fromEntries(
    Array.from({ length: 5 }, (_, index) =>
      Object.entries(personData).map(([key, value]) => [
        `${key}${index + 1}`,
        { ...value, mandatory: index === 0 },
      ])
    ).flat()
  );

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className="font-weight-bold">
            To: Trustees of Alpha LSG Ltd Group Death In Service Scheme
          </p>
          <p>
            If you die before your Pension Date, and a LUMP SUM becomes
            available, where do you want it to be paid?
          </p>
        </div>
      ),
    },
    employeeName: {
      title: "Employee Name",
      value: getVal("employeeName"),
      disabled: true,
      mandatory: true,
    },
    ni: {
      title: "NI No",
      value: getVal("ni"),
      mandatory: true,
    },
    scheme: {
      title: "Scheme",
      value: getVal("scheme"),
      disabled: true,
      mandatory: true,
    },
    blurb2: {
      htmlObj: (
        <div>
          <p className="font-weight-bold">
            I wish to nominate the person or persons shown below.
          </p>
          <p>
            <strong>Note:</strong> If you nominate more than one person, please
            enter proportions as appropriate. You cannot name yourself or your
            estate.
          </p>
        </div>
      ),
    },
    ...personsDataObj,
    blurb3: {
      htmlObj: (
        <div>
          <p className="font-weight-bold">
            Please ensure that the proportions total 100%.
          </p>
          You can change your nomination at a later date by writing to the
          Trustees. You cannot change it so the benefit is payable to yourself
          or your estate.
          <p></p>
        </div>
      ),
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/dnata-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitForm(typeCode, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Nomination of Beneficiary/Expression of Wish"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"dnata"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

WishForm.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitForm: submitDnataExtraForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(WishForm);
